import { useLayoutEffect, useRef, useState } from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ButtonBase,
  Typography,
} from '@mui/material';
import { SnapshotAlarmLogReturn } from 'types';
import AlarmPopup from './AlarmPopup';
import { useUserDateTime } from '../timezone/hooks/useUserDateTime';
import { formatInTimeZone } from 'date-fns-tz';

interface Props {
  alarmLog: SnapshotAlarmLogReturn[];
}

const AlarmWidgetTable = ({ alarmLog }: Props) => {
  const { timeFormat, timezone } = useUserDateTime();
  const [numberOfLogsRendered, setNumberOfLogsRendered] = useState(10);
  const [clickedAlarmLog, setClickedAlarmLog] =
    useState<SnapshotAlarmLogReturn | null>(null);
  const tableElement = useRef<HTMLDivElement | null>(null);

  const scrollListener = () => {
    if (!tableElement.current) return;
    let bottom =
      tableElement.current.scrollHeight - tableElement.current.clientHeight;
    if (
      tableElement.current.scrollTop + 15 >= bottom &&
      numberOfLogsRendered < alarmLog.length
    )
      setNumberOfLogsRendered((currentNumber) => currentNumber + 25);
  };

  useLayoutEffect(() => {
    const tableRef = tableElement.current;
    tableRef?.addEventListener('scroll', scrollListener);
    return () => {
      tableRef?.removeEventListener('scroll', scrollListener);
    };
  });
  return (
    <TableContainer
      sx={{
        maxHeight: '258px',
      }}
      ref={tableElement}
    >
      <Table size='small' stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                backgroundColor: (theme) =>
                  theme.palette.mode === 'dark' ? '#2b3640' : '#fff',
              }}
            >
              Alarm{' '}
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: (theme) =>
                  theme.palette.mode === 'dark' ? '#2b3640' : '#fff',
              }}
            >
              Time
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {alarmLog?.slice(0, numberOfLogsRendered).map((item) => (
            <TableRow
              hover
              sx={{ '&:last-child td': { border: 0 }, cursor: 'pointer' }}
              key={item.id}
              onClick={() => setClickedAlarmLog(item)}
            >
              <TableCell>
                <ButtonBase>
                  <Typography variant='body2'>
                    {item.alarm.name +
                      (item.snapshot_alarm_log_items?.some((logItem) =>
                        logItem.message.includes('Warning Mode: On')
                      )
                        ? ' (Warning)'
                        : '')}
                  </Typography>
                </ButtonBase>
              </TableCell>
              <TableCell>
                <ButtonBase>
                  <Typography variant='body2'>
                    {formatInTimeZone(
                      new Date(item.time),
                      timezone,
                      timeFormat
                    )}
                  </Typography>
                </ButtonBase>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <AlarmPopup
        item={clickedAlarmLog}
        handleClose={() => setClickedAlarmLog(null)}
      />
    </TableContainer>
  );
};
export default AlarmWidgetTable;
